import React from 'react';
import { Redirect } from 'react-router-dom';

import dashboardRoutes from './views/dashboard/DashboardRoutes';
import sessionRoutes from './views/sessions/SessionRoutes';

import paymentRoutes from './views/payments/PaymentRoutes';
import contactRoutes from './views/contacts/ContactRoute';
import merchantRoutes from './views/merchant/MerchantRoutes';
import adminRoutes from './views/admin/AdminRoutes';
import docRoutes from './views/doc/DocRoutes';
import billingRoutes from './views/billing/BillingRoutes';
import invoiceRoutes from './views/invoices/InvoiceRoutes';

const redirectRoute = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to='/dashboard/merchant' />
  }
];

const errorRoute = [
  {
    component: () => <Redirect to='/session/404' />
  }
];

const routes = [
  ...sessionRoutes,
  ...dashboardRoutes,
  ...paymentRoutes,
  ...contactRoutes,
  ...redirectRoute,
  ...merchantRoutes,
  ...adminRoutes,
  ...docRoutes,
  ...billingRoutes,
  ...invoiceRoutes,
  ...errorRoute
];

export default routes;
